module.exports = __webpack_public_path__ + "img/order-detail.dc141fdf.svg";